import { Dialog } from "primereact/dialog";
import { IContact } from "../../models/BaseModel";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { showDateTime } from "../../utilities/helper";

const schema = yup.object({

});

interface Iprops {
    singleData: IContact,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const TransferHistory = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IContact[], count: number, loading: boolean });

    const onHide = () => {
        props.hideDialog();
    }

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`lead/transfer-history/${props.singleData.id}`, "GET", null, null, props.toast);
        if (response) {
            const data: { transferHistory: IContact[], count: number } = await response.json();
            setTableData({ data: data.transferHistory, count: data.count, loading: false });
        } else setTableData((prev) => ({ ...prev, loading: false, }));

    }

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);

    const transferDate = (rowData: any) => {
        return (
            <span>{rowData.transferDate ? format(new Date(rowData.transferDate), 'dd/MM/yyyy hh:mm a') : '-'}</span>
        );
    }


    return (
        <Dialog visible={props.open} style={{ width: '500px' }} header="Transfer History" modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                header=""
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="previousAssignedToId" header="Transfer From" />
                <Column field="newAssignedToId" header="Transfer To" />
                <Column field="transferredById" header="Transfer By" />
                <Column field="transferDate" header="Transfer Date" body={(row) =>
                                        row.transferDate
                                            ? showDateTime(row.transferDate)
                                            : "-"
                                    } />
            </DataTable>
        </Dialog>
    );
}